import { extendTailwindMerge } from "tailwind-merge";

/*
 * Last class wins per property, so `className` overrides baked-in classes.
 * Each entry teaches tailwind-merge a custom utility (tokens.css, utilities.css);
 * colors need none because its `color` scale accepts any name.
 */
export const cn = extendTailwindMerge<
  | "text-annotation-caps"
  | "text-mono-caps"
  | "text-mono-time"
  | "render-pixelated"
  | "bg-hatch"
>({
  extend: {
    theme: {
      radius: ["paper", "sheet", "tag", "swipe", "bubble"],
      // Unlisted, tailwind-merge reads shadow-lift as a shadow *color*, so shadow-none can't displace it.
      shadow: [
        "lift",
        "lift-lg",
        "float",
        "sheet",
        "board",
        "bubble",
        "bubble-asking",
        "halo-listening",
        "halo-thinking",
        "halo-asking",
      ],
      ease: ["paper"],
      // Unlisted, `text-<name>` reads as a color and cancels text-annotation.
      text: ["fine-print", "record-title"],
    },
    classGroups: {
      // The stock z group takes integers and `auto` only, with no theme scale.
      z: [{ z: ["dropdown", "toast"] }],
      // Sets mix-blend-mode without the `mix-` prefix.
      "mix-blend": ["blend-marker"],
      // Own groups: not a "color", and a size class must not drop them.
      "text-annotation-caps": ["text-annotation-caps"],
      "text-mono-caps": ["text-mono-caps"],
      "text-mono-time": ["text-mono-time"],
      "render-pixelated": ["render-pixelated"],
      "bg-hatch": ["bg-hatch"],
    },
  },
});
